import React, { useMemo, useState } from 'react';
import { Layout, Segment } from 'tea-component';
import { FilterFixed, useFilterDataHook } from '@op/components/FilterCommon';
import CommonEChart from './widgets/CommonEChart';
import HashtagTable from './widgets/HashtagTable';
import { connect, useIntl } from 'umi';
import { getHashtagChartDate } from '@op/services/hashtag';
import CardLoading from '@/pages/opinion/components/CardLoading';

import BubbleCommon, {
  communityHashtagTitleText,
} from '@/pages/opinion/components/BubbleCommon';
import '@/pages/opinion/assets/scss/pages/community/hashtag.scss';
import { LanguageType } from '@/pages/opinion/types/common';
import { useInitBuriedPointInfo } from '@/pages/opinion/operationLog/buriedPoint';
import HashtagPoint from '@op/operationLog/pages/hashtag';
import moment from 'moment';
import { dealwithChannelChartKey } from '@/pages/opinion/components/ChannelLabel';
import ContentBody from '@/pages/opinion/components/ContentBody';
import { useGetSingePageSourceRule } from '@op/hooks/useGetPageSourceRule';
import { PAGE_NAME } from '@op/constants/page';
import { DBO_TM } from '@op/utils/format';
const { Content } = Layout;

function HashTag({
  gameInfo,
}: {
  gameInfo: any;
}) {
  const { formatMessage } = useIntl();
  const [type, setType] = useState('accumulated');
  const [lang, setLang] = useState<LanguageType>('origin');
  const { loading, filter, changeFilter, scrollBody, filterOptions } =
    useFilterDataHook({
      pageName: 'Community_Hashtag',
      gameInfo,
    });
  useInitBuriedPointInfo({ buriedPoint: HashtagPoint });
  const byChannel = useMemo(() => {
    return type === 'channel';
  }, [type]);

  const { Sentiment_Rating } = useGetSingePageSourceRule({
    keys: 'Sentiment_Rating',
  });

  return (
    <Content className="dbo-hashtag" ref={scrollBody}>
      <ContentBody
        pageName={PAGE_NAME.HASHTAG}
        contentHeard={
          <Content.Header
            title={formatMessage({ id: PAGE_NAME.HASHTAG })}
            subtitle={
              <span
                className="dbo-header-subtitle "
                style={{ fontSize: 12, color: '#707070' }}
              >
                <BubbleCommon
                  iconStyle={{ marginLeft: 5 }}
                  tipsMap={communityHashtagTitleText}
                >
                  {formatMessage({ id: 'Data Update' })}
                </BubbleCommon>
              </span>
            }
          />
        }
      >
        <FilterFixed
          filter={filterOptions}
          defaultValue={DBO_TM.utcFilterRangeDay(6, 0)}
          confirm={(value) => {
            changeFilter({ ...value, ...gameInfo });
          }}
        ></FilterFixed>
        <Segment
          className="dbo-hashtag-segment segment-light"
          value={type}
          onChange={(value) => setType(value)}
          options={[
            {
              text: formatMessage({ id: 'Accumulated' }),
              value: 'accumulated',
            },
            { text: formatMessage({ id: 'By Channel' }), value: 'channel' },
          ]}
        />
        <CardLoading loading={loading}>
          <CommonEChart
            Sentiment_Rating={Sentiment_Rating}
            getServerDataFunc={(params, cancel) =>
              getHashtagChartDate(
                { ...params, top_n: 20, by_channel: byChannel },
                cancel,
              )
            }
            byChannel={byChannel}
            lineLegendFormatter={(name: string, splitText?: string) => {
              if (byChannel) {
                const [channel, newName] = name?.split(splitText || '') || [];
                return `{${dealwithChannelChartKey(
                  channel,
                )}| } {name| #${newName}}`;
              }
              return name;
            }}
            dealwithName={(name) => (byChannel ? name : '#' + name)}
            filter={filter}
          ></CommonEChart>
          <HashtagTable
            byChannel={byChannel}
            languageType={lang}
            setLanguageType={setLang}
            filter={filter}
            Sentiment_Rating={Sentiment_Rating}
          ></HashtagTable>
        </CardLoading>
      </ContentBody>
    </Content>
  );
}

export default connect((state: { opinionCommon: any }) => {
  const { opinionCommon } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(HashTag);
